module.exports = __webpack_public_path__ + "img/team.d61f3ea.png";